// Optimized WebP variants (800w primary + 400w for srcset), generated by
// scripts/optimize-images.mjs and refreshed by scripts/capture-shots.mjs.
import outbro from '../assets/project_images/outbro-800.webp';
import outbroSm from '../assets/project_images/outbro-400.webp';
import fitwright from '../assets/project_images/fitwright-800.webp';
import fitwrightSm from '../assets/project_images/fitwright-400.webp';
import credible from '../assets/project_images/credible-800.webp';
import credibleSm from '../assets/project_images/credible-400.webp';
import webzed from '../assets/project_images/webzed-800.webp';
import webzedSm from '../assets/project_images/webzed-400.webp';
import threaid from '../assets/project_images/threaid-800.webp';
import threaidSm from '../assets/project_images/threaid-400.webp';
import safe_stree from '../assets/project_images/safe_stree-800.webp';
import safe_streeSm from '../assets/project_images/safe_stree-400.webp';
import ai_podcast from '../assets/project_images/ai_podcast-800.webp';
import ai_podcastSm from '../assets/project_images/ai_podcast-400.webp';
// Temporarily hidden — Student Management System (see entry below)
// import student_management from '../assets/project_images/student_management-800.webp';
// import student_managementSm from '../assets/project_images/student_management-400.webp';

// AVIF variants (smaller than WebP) — served first via <picture>, WebP fallback.
import outbroAvif from '../assets/project_images/outbro-800.avif';
import outbroAvifSm from '../assets/project_images/outbro-400.avif';
import fitwrightAvif from '../assets/project_images/fitwright-800.avif';
import fitwrightAvifSm from '../assets/project_images/fitwright-400.avif';
import credibleAvif from '../assets/project_images/credible-800.avif';
import credibleAvifSm from '../assets/project_images/credible-400.avif';
import webzedAvif from '../assets/project_images/webzed-800.avif';
import webzedAvifSm from '../assets/project_images/webzed-400.avif';
import threaidAvif from '../assets/project_images/threaid-800.avif';
import threaidAvifSm from '../assets/project_images/threaid-400.avif';
import safe_streeAvif from '../assets/project_images/safe_stree-800.avif';
import safe_streeAvifSm from '../assets/project_images/safe_stree-400.avif';
import ai_podcastAvif from '../assets/project_images/ai_podcast-800.avif';
import ai_podcastAvifSm from '../assets/project_images/ai_podcast-400.avif';
// import student_managementAvif from '../assets/project_images/student_management-800.avif';
// import student_managementAvifSm from '../assets/project_images/student_management-400.avif';

export const projects = [
    {
        title: 'Outbro.net',
        image: outbro,
        imageSm: outbroSm,
        imageAvif: outbroAvif,
        imageAvifSm: outbroAvifSm,
        description: 'Outbro.net is an enterprise digital marketplace and AI job engine, architected as a multi-language microservice pipeline. A Python-based ML microservice interfaces with the primary Node.js/Express backend, running localized machine-learning recommendation models and prompt-engineering frameworks to programmatically map candidate profiles to active market opportunities within a high-volume client framework.',
        tech: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Python', 'Machine Learning', 'Microservices', 'REST API'],
        liveLink: 'https://www.outbro.net/',
        githubLink: '',
        media: [{ type: 'image', url: outbro }]
    },
    {
        title: 'FitWright',
        image: fitwright,
        imageSm: fitwrightSm,
        imageAvif: fitwrightAvif,
        imageAvifSm: fitwrightAvifSm,
        description: 'FitWright is a self-hosted modular monolith orchestrating intensive computational workloads. Its multi-stage AI document-processing pipeline is driven by a high-throughput FastAPI/Python backend with a Next.js frontend, fully containerized via Docker under strict GitHub Actions workflows for continuous delivery. The pipeline is pluggable across multiple LLM providers and returns ATS-style compliance scoring against target job descriptions.',
        tech: ['Next.js', 'React.js', 'TypeScript', 'FastAPI', 'Python', 'RAG', 'Docker', 'GitHub Actions', 'CI/CD'],
        liveLink: 'https://fitwright.tech',
        githubLink: 'https://github.com/ObaidGits/FitWRight',
        media: [{ type: 'image', url: fitwright }]
    },
    {
        title: 'Threaid',
        image: threaid,
        imageSm: threaidSm,
        imageAvif: threaidAvif,
        imageAvifSm: threaidAvifSm,
        description: 'Threaid is a client-built B2B textile ecommerce web app that connects buyers with verified suppliers through structured catalog discovery and AI-assisted sourcing. It supports buyer and supplier workflows end-to-end, including product comparison, inventory-aware ordering, and supplier onboarding with business-centric constraints like MOQ, lead-time planning, and pricing tiers.',
        tech: ['React.js', 'Node.js', 'Express.js', 'TypeScript', 'MongoDB', 'Tailwind CSS', 'TanStack Query', 'Zod', 'JWT', 'LLM Integration'],
        liveLink: 'https://threaid-api.onrender.com/',
        githubLink: '',
        media: [
            { type: 'image', url: threaid }
        ]
    },
    {
        title: 'SafeStree',
        image: safe_stree,
        imageSm: safe_streeSm,
        imageAvif: safe_streeAvif,
        imageAvifSm: safe_streeAvifSm,
        description: 'SafeStree is a real-time women-safety platform built on a dual-engine architecture that combines computer vision with low-latency networking. A Python/OpenCV vision layer performs real-time hand-gesture distress detection, while persistent Socket connections and WebRTC media channels orchestrate low-latency SOS alerts and real-time P2P video streaming, relaying GPS and identity data to the nearest response point.',
        tech: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Python', 'OpenCV', 'Flask', 'WebRTC', 'Socket.io', 'GPS API'],
        liveLink: 'https://safe-stree.netlify.app/',
        githubLink: 'https://github.com/ObaidGits/safe-stree-unified',
        media: [
            { type: 'video', url: 'https://res.cloudinary.com/dl7gg1sej/video/upload/v1747338504/safe-stree.mp4' },
            { type: 'image', url: 'https://res.cloudinary.com/dl7gg1sej/image/upload/v1747397007/sf-2.jpg' },
            { type: 'image', url: 'https://res.cloudinary.com/dl7gg1sej/image/upload/v1747397007/sf-3.jpg' },
            { type: 'image', url: 'https://res.cloudinary.com/dl7gg1sej/image/upload/v1747397007/sf-4.jpg' },
            { type: 'image', url: 'https://res.cloudinary.com/dl7gg1sej/image/upload/v1747397007/sf-5.jpg' },
            { type: 'image', url: 'https://res.cloudinary.com/dl7gg1sej/image/upload/v1747397007/sf-6.jpg' }
        ]
    },
    {
        title: 'CredibleAssist.com',
        image: credible,
        imageSm: credibleSm,
        imageAvif: credibleAvif,
        imageAvifSm: credibleAvifSm,
        description: 'CredibleAssist.com is a platform offering emergency medical assistance to international travelers. It connects users with local medical support, ensuring safety and prompt care during travel emergencies.',
        tech: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'PHP'],
        liveLink: 'https://www.credibleassist.com/',
        githubLink: '',
        media: [{ type: 'image', url: credible }]
    },
    {
        title: 'Webzed',
        image: webzed,
        imageSm: webzedSm,
        imageAvif: webzedAvif,
        imageAvifSm: webzedAvifSm,
        description: 'Webzed is a freelance portfolio website to showcase services, manage clients, and deliver projects. It enhances online presence and client engagement for freelancers.',
        tech: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'Vanilla Js', 'Animate on Scroll'],
        liveLink: 'https://my-webzed.netlify.app/',
        githubLink: '',
        media: [{ type: 'image', url: webzed }]
    },
    {
        title: 'AI Podcast Generator',
        image: ai_podcast,
        imageSm: ai_podcastSm,
        imageAvif: ai_podcastAvif,
        imageAvifSm: ai_podcastAvifSm,
        description: 'AI Podcast Generator creates podcast scripts using OpenAI and converts them to audio using ElevenLabs. It automates content creation, making podcast production more efficient.',
        tech: ['OpenAI API', 'ElevenLabs', 'Pydub', 'Python', 'FFmpeg'],
        liveLink: 'https://www.linkedin.com/posts/obaidullah-zeeshan_ai-python-chatgpt-activity-7325625658183745536-Hux9?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEfJ6MkBGVGp7ySZn-HUbDgQE4PGAKR-zKA',
        githubLink: 'https://github.com/ObaidGits/ai_podcast_generator',
        media: [
            { type: 'image', url: ai_podcast },
            { type: 'video', url: 'https://res.cloudinary.com/dl7gg1sej/video/upload/v1747376118/ai-podcast.mp4' }
        ]
    }
    // Temporarily hidden — Student Management System
    // {
    //     title: 'Student Management System',
    //     image: student_management,
    //     imageSm: student_managementSm,
    //     imageAvif: student_managementAvif,
    //     imageAvifSm: student_managementAvifSm,
    //     description: 'Student Management System is a MERN stack application for managing student records, attendance, and administration. It simplifies academic management for educational institutions.',
    //     tech: ['MongoDB', 'Express.js', 'React.js', 'Node.js'],
    //     liveLink: 'https://mern-management.netlify.app/',
    //     githubLink: 'https://gist.github.com/ObaidGits/7c2bac646d467b18a130796fa51b2fe3',
    //     media: [{ type: 'image', url: student_management }]
    // }
];
